import { shouldPolyfill } from '@formatjs/intl-durationformat/should-polyfill'
import {
  PUBLIC_API_INTERNAL_ORIGIN,
  PUBLIC_SENTRY_ENVIRONMENT,
  PUBLIC_API_GATEWAY_ORIGIN,
  PUBLIC_SENTRY_DSN
} from '$env/static/public'
import {
  graphqlClientIntegration,
  handleErrorWithSentry,
  init as sentryInit,
  setTag
} from '@sentry/sveltekit'

const websocket = new URL(PUBLIC_API_GATEWAY_ORIGIN)
websocket.protocol = websocket.protocol.replace(/^http/, 'ws')

sentryInit({
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  dsn: PUBLIC_SENTRY_DSN,
  environment: PUBLIC_SENTRY_ENVIRONMENT,
  integrations: [
    graphqlClientIntegration({
      endpoints: [
        '/api',
        String(websocket),
        PUBLIC_API_GATEWAY_ORIGIN,
        String(new URL('/api', PUBLIC_API_INTERNAL_ORIGIN))
      ]
    })
  ]
})

const client = document.cookie.match(/(?:^|;\s*)aa.client=(.+?)(?:;|$)/)
if (client) setTag('client', client[1])

const session = document.cookie.match(/(?:^|;\s*)aa.session=(.+?)(?:;|$)/)
if (session) setTag('session', session[1])

export const handleError = handleErrorWithSentry()

export async function init() {
  if (shouldPolyfill()) {
    await import('@formatjs/intl-durationformat/polyfill-force')
  }
}
